import { render, staticRenderFns } from "./CustomerProposalHistoryValuesTable.vue?vue&type=template&id=476a526c"
import script from "./CustomerProposalHistoryValuesTable.vue?vue&type=script&lang=js"
export * from "./CustomerProposalHistoryValuesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports